var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"block-title"},[_c('i',{staticClass:"dot left"}),_c('span',[_vm._v(_vm._s(_vm.title))]),_c('i',{staticClass:"dot right"})])}
var staticRenderFns = []

export { render, staticRenderFns }